import { render } from "./PageExpired.vue?vue&type=template&id=81ec0e60&scoped=true"
import script from "./PageExpired.vue?vue&type=script&lang=js"
export * from "./PageExpired.vue?vue&type=script&lang=js"

import "./PageExpired.vue?vue&type=style&index=0&id=81ec0e60&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ec0e60"]])

export default __exports__